import { CreateOrderModel } from "../../Services/Models/Order/OrderModel";
import { postLeads } from "./APIResources";
import { axiosWithToken } from "../../Services/Axios";

export async function orderPlaced(orders: CreateOrderModel) {
    try{
        return await axiosWithToken.post(`${postLeads}`, orders);
    }catch(error: any){
        return { success: false, code: error.code || error.toString(), message: error.message || error.toString() };
    }
}